/* global zaraz */
import { IS_FRAME_SERVICE } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/frameService';

export const ACCOMMODATION_LINK_ABOVE_GUIDE_ARTICLE_CLICK = 'AccommodationLinkAboveGuideArticleClick';
export const ACCOMMODATION_LINK_BELOW_GUIDE_ARTICLE_CLICK = 'AccommodationLinkBelowGuideArticleClick';
export const MAIN_MENU_CLICK = 'MainMenuClick';
export const ARTICLE_SOCIAL_SHARE = 'ArticleSocialShare';
export const PROVIDER_ACQUISITION_HEADER_CLICK = 'ProviderAcquisitionHeaderClick';
export const PROVIDER_ACQUISITION_MENU_CLICK = 'ProviderAcquisitionMenuClick';
export const UNIT_PRESENTATION_SIGN_IN_CLICK = 'UnitPresentationSignInClick';
export const PAGE_VIEW_PILLAR_PAGE = 'PageViewPillarPage';

const dispatchTrackingEvent = (eventName) => {
    if (typeof zaraz !== 'undefined' && zaraz.consent && !IS_FRAME_SERVICE) {
        const marketing = zaraz.consent.get('KlIi');
        if (marketing) {
            if (zaraz.track) {
                zaraz.track(eventName);
            }
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: eventName,
            });
        }
    }
};

const dispatchDataLayerTrackingEvent = (eventName) => {
    if (typeof zaraz !== 'undefined' && zaraz.consent && !IS_FRAME_SERVICE) {
        const marketing = zaraz.consent.get('KlIi');
        if (marketing) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: eventName,
            });
        }
    }
};

export { dispatchDataLayerTrackingEvent };
export default dispatchTrackingEvent;
